import "../styles/Reserva.css";

import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

import Navbar from "../components/Navbar";
import ReservaForm from "../components/ReservaForm";

function Reserva() {
  const navigate = useNavigate();

  const [saliendo, setSaliendo] = useState(false);
  const temporizador = useRef(null);

  const volver = () => {
    if (saliendo) return;

    setSaliendo(true);

    temporizador.current = setTimeout(() => {
      const indiceHistorial = window.history.state?.idx;

      if (
        typeof indiceHistorial === "number" &&
        indiceHistorial > 0
      ) {
        navigate(-1);
      } else {
        navigate("/", { replace: true });
      }
    }, 450);
  };

  useEffect(() => {
    return () => {
      if (temporizador.current) {
        clearTimeout(temporizador.current);
      }
    };
  }, []);

  return (
    <div
      className={`reservaPageWrapper ${
        saliendo ? "reservaPageLeaving" : ""
      }`}
    >
      <Navbar />

      <main className="reserva-page">
        <div className="reservaPageTop">
          <button
            type="button"
            className="reservaPageBackButton"
            onClick={volver}
            disabled={saliendo}
          >
            <span className="reservaPageBackIcon">
              <FaArrowLeft />
            </span>

            <span>
              {saliendo ? "Volviendo..." : "Volver"}
            </span>
          </button>

          <div className="reservaPageTopLine"></div>

          <span className="reservaPageTopLabel">
            RESIDENCIAL YANNA I
          </span>
        </div>

        <div className="reservaPageFormContent">
          <ReservaForm />
        </div>
      </main>

      <div className="reservaPageTransitionLayer"></div>
    </div>
  );
}

export default Reserva;